import type { TypedUseQuery } from '@reduxjs/toolkit/query/react';

/**
 * Copied from @reduxjs/toolkit/query/react
 * Without selectFromResult because it would make types complex
 * (These types are not exported and computing them would be complicated)
 */
export type RTKQueryOptions = {
    pollingInterval?: number | undefined;
    skipPollingIfUnfocused?: boolean | undefined;
    refetchOnReconnect?: boolean | undefined;
    refetchOnFocus?: boolean | undefined;
    skip?: boolean | undefined;
    refetchOnMountOrArgChange?: boolean | number | undefined;
};

export const withSkip = <T extends RTKQueryOptions | undefined>(options: T, skip: boolean): T => {
    if (!options && !skip) {
        return options;
    }
    return { ...(options ?? {}), skip: options?.skip || skip } as T;
};

// biome-ignore lint/suspicious/noExplicitAny: refetch exists only in query not in mutations
type RtkQueryResult = Omit<ReturnType<TypedUseQuery<any, any, any>>, 'refetch'>;

export const withLoadingState = <T extends RtkQueryResult>(result: T, loading: boolean): T => {
    const current = result;
    return {
        ...result,
        isLoading: loading || Boolean(current.isLoading),
        isFetching: current.isFetching !== undefined ? loading || Boolean(current.isFetching) : current.isFetching,
        isUninitialized: loading || Boolean(current.isUninitialized),
    } as T;
};
